// Shared by `api.ts` and `auth-service.ts` — kept in its own module because
// `api.ts` imports `getToken` from `auth-service.ts`, so `auth-service.ts`
// cannot import this back from `api.ts` without a circular dependency.
export const API_BASE_URL = import.meta.env.VITE_API_URL ?? 'http://localhost:3001';
